import React from 'react'
import axios from 'axios'
import {
  List, Box, Typography, Input, Select, MenuItem, Button, Divider, Menu, FormControl, FormGroup, Checkbox, Radio, FormControlLabel, RadioGroup,
  TableContainer, Table, TableRow, TableHead, TableBody, TableCell, Paper
} from '@mui/material'
import { TextField, EditButton } from 'react-admin'
import globalStyles from '../../utils/globalStyles'
import { StyledTableCell, StyledTableRow } from '../common/StyledTableElements'
import legolasApi from '../../api/legolas'
import { remove, isArray } from 'lodash';
import EditIcon from '@mui/icons-material/Edit';
import { useNavigate } from 'react-router-dom';

function OrderShipmentList(props) {
  const [columnsOpen, setColumnsOpen] = React.useState(false)
  const { summary, items, shipment, transaction, customer } = props.data
  const [selectedHeaders, setSelectedHeaders] = React.useState([
    {id: 'incrementId', label: 'Shipment No.'}, {id: 'orderId', label: 'Order ID'}, {id: 'awbNumber', label: 'AWB #'}, 
    {id: 'customerId', label: 'Customer ID'}, {id: 'shippingId', label: 'Shipping Partner'}, 
    {id: 'totalQuantity', label: 'Total Qty'}, 
    // { id: 'totalWeight', label: 'Total Weight' },
    // { id: 'viewpackage', label: 'Action'}
  ]);
  
  const [listData, setListData] = React.useState([])

  const allTableHeaders = [
    { id: 'orderId', label: 'Order ID' }, { id: 'awbNumber', label: 'AWB #' }, { id: 'customerId', label: 'Customer ID' },
    { id: 'shippingId', label: 'Shipping Partner' },
    { id: 'totalQuantity', label: 'Total Qty' }, { id: 'totalWeight', label: 'Total Weight' }
  ]

  const navigate = useNavigate();

  React.useEffect(() => {
    let submitPayload = {
      "orderId": summary.order_id,
      "type": "shipment"

    }
    axios.post(`${legolasApi.url}/orders/order/particular`, submitPayload).then((res) => {
      console.log('Response: ', res)
      const data = res.data
      if (data.data && isArray(data.data)) {
        setListData(res.data.data);
      } else {
        setListData([])
      }
      console.log(res.data);
    })
  }, [])

  function selectHeader(headerId, headerLabel) {
    const headerObj = { "id": headerId, "label": headerLabel }
    const currentSelected = selectedHeaders
    currentSelected.push(headerObj)
    setColumnsOpen(false)
    setSelectedHeaders(currentSelected)
  }

  function resetTableHeaders() {
    setSelectedHeaders([
      { id: 'orderId', label: 'Order ID' }, { id: 'awbNumber', label: 'AWB #' }, { id: 'customerId', label: 'Customer ID' },
      { id: 'shippingId', label: 'Shipping Partner' },
      { id: 'totalQuantity', label: 'Total Qty' }, { id: 'totalWeight', label: 'Total Weight' }
    ])
    setColumnsOpen(false)
  }

  const handleEdit = (orderId) => {
    const link =  `/shipment/${orderId}`
    navigate(link);
  }

  if (listData == []) return null
  return (
    <React.Fragment>
      <List actions={null}>
        <Box sx={globalStyles.headerWrapperBox}>
          <Box sx={{ width: '50%', display: 'flex', margin: '20px 30px' }}>
            <Typography variant='h4'>Shipments</Typography>
          </Box>
        </Box>
        <Box>
          {
            isArray(listData) && listData.length > 0 ?
              <TableContainer component={Paper} sx={{ margin: '20px 30px', width: '94%' }}>
                <Table aria-label="simple table">
                  <TableHead sx={{
                    backgroundColor: globalStyles.colors.backgroundPrimary,
                    height: '40px !important',
                    borderRadius: '0 !important',
                    '& .MuiTableCell-root': {
                      color: '#fff !important',
                      padding: '10px !important',
                      borderRight: '2px solid #fff !important',
                      borderRadius: '0 !important'
                    }
                  }}>
                    {selectedHeaders.map((header) => [
                      <TableCell align='center'>{header.label}</TableCell>
                    ])}
                  </TableHead>
                  <TableBody>
                    {
                      listData.map(shipment => {
                        return (
                          <StyledTableRow>
                            <StyledTableCell align='center'>
                              {shipment.shipmentNumber}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.orderId}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.shipdetail ? shipment.shipdetail[0].tracking_number : null}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.customerId}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.shipdetail ? shipment.shipdetail[0].transporter : null}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.itemcount}
                            </StyledTableCell>
                            <StyledTableCell align='center'>
                              {shipment.totalWeight}
                            </StyledTableCell>
                            {/* <StyledTableCell align='center'>
                              <EditIcon sx={{ cursor: 'pointer', color: '#2b3f7a'}} onClick={() => handleEdit(shipment.orderId)}/>
                            </StyledTableCell> */}
                          </StyledTableRow>
                        );
                      })
                    }
                  </TableBody>
                </Table>
              </TableContainer>
              :
              <Box>
                <Typography variant='subtitle1' sx={{ fontSize: '1.1rem', fontStyle: 'oblique' }}>No items added in Shipments</Typography>
              </Box>
          }
        </Box>
      </List>
    </React.Fragment>
  )
}
export default OrderShipmentList